import { logger } from '@lusha/client-logger';
import { flow, getRoot } from 'mobx-state-tree';
import { getUserActivity, submitContactsActivity, submitUserFeedback } from '../../../API/userActivityApi';
import browserDetails from '../../../utils/detectBrowser';
const Actions = self => ({
    fetchUserActivity: flow(function* fetchUserActivity() {
        self.isLoading = true;
        try {
            const data = yield getUserActivity();
            self.firstOpenedAt = (data === null || data === void 0 ? void 0 : data.firstOpenedAt) || null;
            self.lastOpenedAt = (data === null || data === void 0 ? void 0 : data.lastOpenedAt) || null;
            self.totalOpens = (data === null || data === void 0 ? void 0 : data.totalOpens) || 0;
            self.showRatePopup = (data === null || data === void 0 ? void 0 : data.showRatePopup) || false;
            self.latestFeedback = (data === null || data === void 0 ? void 0 : data.latestFeedback) || null;
            self.totalContactRevealsCount = (data === null || data === void 0 ? void 0 : data.totalContactRevealsCount) || 0;
            self.isLoaded = true;
        }
        catch (error) {
            logger.warn('Failed to fetch user activity:', error);
            self.isLoaded = true;
        }
        finally {
            self.isLoading = false;
        }
    }),
    submitFeedback: flow(function* submitFeedback({ starRating, feedbackText, storeRedirected = false, dismissalType = 'soft', }) {
        var _a, _b;
        try {
            const { userSettings, user } = getRoot(self);
            const extensionVersion = (userSettings === null || userSettings === void 0 ? void 0 : userSettings.externalPluginVersion) || null;
            const browserType = (browserDetails === null || browserDetails === void 0 ? void 0 : browserDetails.browser) || null;
            const subscriptionTier = (_b = (_a = user === null || user === void 0 ? void 0 : user.billing) === null || _a === void 0 ? void 0 : _a.category) !== null && _b !== void 0 ? _b : '';
            const feedbackData = {
                extensionVersion,
                browserType,
                starRating,
                feedbackText: feedbackText || null,
                triggerAction: self.currentTriggerAction,
                storeRedirected,
                dismissalType,
                subscriptionTier,
            };
            const response = yield submitUserFeedback(feedbackData);
            self.latestFeedback = response || null;
            return response;
        }
        catch (error) {
            logger.warn('Failed to submit feedback:', error);
            throw error;
        }
    }),
    checkAndShowRateModal: flow(function* checkAndShowRateModal(triggerAction) {
        try {
            if (!self.isModalVisible) {
                yield self.fetchUserActivity();
                self.currentTriggerAction = triggerAction;
                if (self.showRatePopup) {
                    setTimeout(() => {
                        self.setModalVisible(true);
                    }, 3000);
                }
            }
        }
        catch (error) {
            logger.warn('Failed to check rate modal:', error);
        }
    }),
    setModalVisible(value) {
        self.isModalVisible = value;
        if (!value) {
            self.currentRate = null;
            self.currentTriggerAction = null;
        }
    },
    setCurrentRate(rate) {
        self.currentRate = rate;
    },
    reportContactsRevealed: flow(function* reportContactsRevealed({ action, contacts }) {
        if (!action || !(contacts === null || contacts === void 0 ? void 0 : contacts.length))
            return;
        try {
            yield submitContactsActivity({ action, contacts });
        }
        catch (error) {
            logger.warn('Failed to report contacts revealed', error);
        }
    }),
    handleStoreRedirect: flow(function* handleStoreRedirect() {
        try {
            yield self.submitFeedback({
                starRating: 5,
                storeRedirected: true,
                dismissalType: null,
            });
        }
        catch (error) {
            logger.warn('Failed to submit store redirect:', error);
        }
        self.setModalVisible(false);
        self.setCurrentRate(null);
    }),
    handleFeedbackSubmit: flow(function* handleFeedbackSubmit(feedbackText) {
        let data;
        try {
            data = yield self.submitFeedback({
                starRating: self.currentRate || null,
                feedbackText,
                dismissalType: null,
            });
        }
        catch (error) {
            logger.warn('Failed to submit feedback:', error);
        }
        self.setModalVisible(false);
        self.setCurrentRate(null);
        return data;
    }),
    handleSkip: flow(function* handleSkip() {
        try {
            yield self.submitFeedback({
                starRating: self.currentRate || null,
                dismissalType: 'soft',
            });
        }
        catch (error) {
            logger.warn('Failed to submit skip:', error);
        }
        self.setModalVisible(false);
        self.setCurrentRate(null);
    }),
    handleModalClose: flow(function* handleModalClose() {
        try {
            yield self.submitFeedback({
                starRating: self.currentRate || null,
                dismissalType: self.currentRate ? 'soft' : 'hard',
            });
        }
        catch (error) {
            logger.warn('Failed to submit dismissal:', error);
        }
        self.setModalVisible(false);
        self.setCurrentRate(null);
    }),
});
export default Actions;
